import React from 'react';
import { ContentProvider, useContentful } from './contentful/ContentContext';
import Header from './components/Header';
import { Route, Routes } from 'react-router';
import Page from './components/Page';
import HomePage from './components/HomePage';
import Footer from './components/Footer';
import './App.scss';

function Layout() {
  const { getEntriesByType, loading } = useContentful();
  const pages = getEntriesByType('page');

  return (
    <div className="appWrapper">
      {loading ? (
        <div className="loader">
          <span className="spinner" />
        </div>
      ) : (
        <>
          <Header />
          <main className="appMain">
            <Routes>
              <Route path="/" element={<HomePage />} />
              {pages.map((page) => (
                <Route
                  key={page.fields.url}
                  path={page.fields.url}
                  element={<Page pageId={page.fields.id} standalone />}
                />
              ))}
            </Routes>
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

// Main App component
const App: React.FC = () => {
  return (
    <ContentProvider>
      <Layout />
    </ContentProvider>
  );
};

export default App;
